import AutoComplete from "../AutoComplete";
import { SelectProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";

const FormAutocomplete = <OptionRetType extends (string | number | boolean) | (string | number | boolean)[]>(props: SelectProps<OptionRetType>) => {
  const { formProps, baseProps } = destructProps<SelectProps<OptionRetType>>(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";

  return (
    <AutoComplete
      {...baseProps}
      value={form?.value}
      onChange={(val) => form?.onChange && form.onChange(val)}
      error={error && helperText}
    />
  );
}

export default FormAutocomplete